<!--
 * @Author: Latte
 * @Date: 2022-01-04 15:41:03
 * @LAstEditors: Latte
 * @LastEditTime: 2022-01-14 17:03:08
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\cloudStorage\index.vue
-->
<template>
  <div
    v-loading.fullscreen="loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  ></div>
</template>

<script>
export default {
  created() {
    this.loading = true;
    setTimeout(() => {
      window.open(process.env.VUE_APP_FILE_SERVICE_URL);
      this.loading = false;
    }, 1000);
  },
  data() {
    return {
      loading: false,
    };
  },
};
</script>

<style>
</style>